import isEmpty from "lodash/isEmpty";
import decodeQueryStringService from '@/components/base_components/tables/services/decode-query-string-service';

export default {
  isEmptyFilterValue(value) {

    if (value == undefined) {
      // must be empty then
      return true;
    }

    if (_isNumber(value) || _isString(value) || _isBoolean(value)) {
      // can't be empty then
      return false;
    }

    // is collection || object
    return isEmpty(value);
  },
  getColumnsAndFiltersOf(preset) {
    let presetObj = {
      ...preset?.data,
      saveColumns: preset.data.query.includes('headers'),
    };

    let query = presetObj.query.substring(1, presetObj.query.length); // delets ? in front of string

    let columnObj = null;
    if (presetObj.saveColumns === true) {
      const indexOfSortBy = query.indexOf('&sortBy=');
      const columnQuerySubString = query.substring(indexOfSortBy, query.length);
      columnObj = decodeQueryStringService.generateColumnObjectsOutOfQueryString(columnQuerySubString);

      query = query.substring(0, indexOfSortBy);
    }

    const filterObj = decodeQueryStringService.generateFilterObjectsOutOfQueryString(query);

    return  { columnObj, filterObj, presetObj };
  },
  generateTruncateOptions(headers, dynamicTruncateOptions) {
    let truncateOptions = {};

    headers.filter(header => header.truncateAfter)
      .forEach((header) => {
        const dynamicLength = dynamicTruncateOptions?.[header.value];

        truncateOptions[header.value] = {
          length: dynamicLength !== undefined ? dynamicLength : header.truncateAfter,
          unit: header.truncateUnit
        }
      });

    return truncateOptions ?? {};
  },
}

const _isNumber = (value) => {
  return typeof value == "number";
}

const _isString = (value) => {
  return typeof value == "string";
}

const _isBoolean = (value) => {
  return typeof value == "boolean";
}
